interface MfcNotificationOptions extends NotificationOptions {
    message: string
    onclick: () => void
}

type MfcNotificationType = {
    requestPermission: () => Promise<boolean>
    new: (options: MfcNotificationOptions) => Promise<void>
    permission?: NotificationPermission
}

export const MfcNotification: MfcNotificationType = {
    requestPermission: async function () {
        if (!('Notification' in window)) {
            console.warn('This browser does not support desktop notifications')
            return false
        }
        if (MfcNotification.permission === 'granted') {
            return true
        }
        if (MfcNotification.permission === 'denied') {
            return false
        }
        const permission = await Notification.requestPermission()
        MfcNotification.permission = permission
        return permission === 'granted'
    },
    new: async function (options: MfcNotificationOptions) {
        if (typeof options !== 'object' || !options.message) {
            return
        }
        if (typeof window === 'undefined' || typeof document === 'undefined') {
            return
        }
        if (document.hasFocus()) {
            return
        }
        const pemissionGranted = await MfcNotification.requestPermission()
        if (!pemissionGranted) {
            return
        }
        const notification = new Notification(options.message, options)
        notification.onclick = function (event) {
            event.preventDefault()
            if (typeof options.onclick === 'function') {
                options.onclick()
            }
            this.close()
        }
        setTimeout(notification.close.bind(notification), 5000)
    },
}
